import EventCreationModalV2 from "./EventCreationModalV2.js";
export default EventCreationModalV2;
